import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextField,{staticStyle:{"max-width":"300px"},attrs:{"prepend-icon":"search","label":"Suchen...","value":_vm.search,"single-line":"","hide-details":""},on:{"input":value => _vm.$emit('update:search', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }